// extracted by mini-css-extract-plugin
module.exports = {"img100":"ArticleBox-module--img100--2Ut9a","box":"ArticleBox-module--box--2zUla","text":"ArticleBox-module--text---16LH"};